module.exports = "/images/geolocate.png?ac713cc2a14f7f102f260eb3abee90b3";